module.exports = __webpack_public_path__ + "static/media/03GalleryPuppets.eef7726d.jpeg";